import { PropsWithChildren, memo } from "react";
import { ErrorBoundary as Boundary } from "react-error-boundary";

import { ErrorFallback } from "./ui/error-fallback";

// Bugsnag is lazy-loaded only when actually needed (on errors)
// No need to import here - it will be loaded when BugsnagSafe is used

export const ErrorBoundary = memo(({ children }: PropsWithChildren) => {
  // For simplicity, just use the react-error-boundary component
  return <Boundary FallbackComponent={ErrorFallback}>{children}</Boundary>;
});
